// 添加原料
<template>
    <a-modal :visible="visible.batchAddRawImport" @ok="ok" :bodyStyle="{ padding: '10px' }" :destroyOnClose="true"
        :forceRender="true" @cancel="toggleVisible('batchAddRawImport')" width="900px">
        <span class="title" slot="title">导入原料</span>

        <a-spin :spinning="addLoading">
            <a-space style="padding: 0 0 10px">
                <a-input-search :allowClear="true" size="small" v-model="filterData.name"
                    @change="(e) => inputChange(e, 'name')" placeholder="原料名称/代码" style="width: 180px"
                    @search="(e) => onSearch(e, 'name')" />
                <a-input-search v-if="overseasFlag == 1" size="small" v-model="filterData.aliasName"
                    @change="(e) => inputChange(e, 'aliasName')" placeholder="原料别名" style="width: 180px"
                    @search="(e) => onSearch(e, 'aliasName')" />
                <base-list-select style="width: 180px" :value="rawType" @change="typeChange" placeholder="选择原料类型"
                    category="raw" />
            </a-space>
            <a-table :columns="columns" bordered :scroll="{ x: 870, y: 450 }"
                :row-selection="{ selectedRowKeys, onChange: onSelectChange }" :loading="nutLoading"
                :data-source="list.records" :row-key="(record) => record.id" :pagination="false">
                <template slot="name" slot-scope="text, record">
                    {{ overseasFlag == "1" ? record.aliasName || text : text }}
                </template>
                <template slot="fixed3" slot-scope="t">{{
                    t || t === 0 ? Number(t).toFixed(3) : t
                    }}</template>
                <template slot="rawTypeName" slot-scope="text, record, index">
                    <a-tooltip @visibleChange="rawTypeNameTipsVisibleChange($event, record, index)">
                        <template slot="title">
                            {{ record.fullTypeName }}
                        </template>
                        <span style="cursor: pointer" :style="{ color: record.color }">{{ text }}</span>
                    </a-tooltip>
                </template>
                <div slot="status" slot-scope="text, record">
                    <span :style="{ color: !text ? 'green' : 'red' }">{{
                        !text ? "激活" : "失效"
                        }}</span>/{{ record.categoryTypeName ? record.categoryTypeName : "-" }}
                </div>
            </a-table>
        </a-spin>
    </a-modal>
</template>
<script>
import BaseListSelect from '../../Nhf/Compound/select/BaseListSelect.vue';
import { formulaMixins } from '../unitls';
export default {
    components: { BaseListSelect },
    props: ['hidden'],
    mixins: [formulaMixins],
    data() {
        return {
            overseasFlag: window.localStorage.getItem('overseasFlag'),
            nutLoading: false,
            filterData: {},
            list: {},
            rawType: [],
            addLoading: false,
            status: undefined,
            columns: [
                {
                    dataIndex: 'name',
                    title: '原料名称',
                    scopedSlots: { customRender: 'name' },
                },
                {
                    dataIndex: 'code',
                    align: 'center',
                    title: '代码',
                    width: 110
                },
                {
                    dataIndex: 'rawTypeName',
                    title: '类型',
                    width: 200,
                    scopedSlots: { customRender: 'rawTypeName' },
                },
                {
                    title: "库存量",
                    dataIndex: "storageWeight",
                    width: 120,
                    ellipsis: true,
                    align: 'center',
                    scopedSlots: { customRender: "fixed3" },
                },
                {
                    title: "单位",
                    dataIndex: "unit",
                    width: 80,
                    ellipsis: true,
                },
                {
                    title: '状态/类目归属',
                    dataIndex: 'status',
                    width: 120,
                    scopedSlots: { customRender: 'status' }
                },
            ]
        };
    },

    watch: {
        'visible.batchAddRawImport'(val) {
            val ? this.getList() : this.restList();
        }
    },

    methods: {
        inputChange({ target }, field) {
            this.getList({
                [field]: target.value
            });
        },

        async ok() {
            if (this.selectedRows.length) {
                this.toggleVisible('batchAddRawImport');
                this.$emit('ok', { rows: this.selectedRows });
            } else
                this.$message.warn('选择需要添加的原料');
        },

        async getList(arg = {}) {
            await this.fetchGet({
                actions: this.myRawpage,
                isList: true,
                name: 'list',
                loading: 'nutLoading',
                data: {
                    ...this.filterData,
                    factoryId: this.factoryId,
                    ...arg,
                    size: 2000,
                    status: this.status,
                }
            });
        },

        restList() {
            this.filterData = {};
            this.rawType = [];
            this.cleanSelect();
        },

        onSearch(name, field) {
            this.getList({
                [field]: name
            });
        },

        typeChange(val) {
            this.rawType = val;
            const typeId = [...val].pop();
            this.filterData.typeId = typeId;
            this.getList({
                typeId
            });
        },
        rawTypeNameTipsVisibleChange(show, item, index) {
            item.color = show ? '#1677FF' : '';
            this.$set(this.list.records, index, item);
        },
    }
};
</script>
<style lang="scss" scoped>
.title {
    display: flex;
    align-items: center;

    b {
        font-size: 12px;
        font-weight: normal;
        color: #999;
        margin-left: 10px;
    }
}
</style>
